import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../..";
import { getChatbotHeight, getChatbotWidth } from "../../../socket/utils/utils";

interface Props {
  width: number;
  height: number;
  actualHeight?: number;
  actualWidth?: number;
}

let INITIAL_STATE: Props = {
  width: 0,
  height: 0,
  actualHeight: 0,
  actualWidth: 0
};

const DeviceSizeSlice = createSlice({
  name: "DeviceSizeSlice",
  initialState: INITIAL_STATE,
  reducers: {
    setDeviceSize(state, { payload }: PayloadAction<Props>) {
      const wh = {
        height: getChatbotHeight(payload.width, payload?.height),
        width: getChatbotWidth(payload.width),
        actualHeight: payload?.height - 8,
        actualWidth: payload?.width
      };
      state.width = wh.width;
      state.height = wh.height;
      state.actualHeight = wh.actualHeight;
      state.actualWidth = wh.actualWidth;
    },
  },
});

export default DeviceSizeSlice.reducer;
export const { setDeviceSize } = DeviceSizeSlice.actions;

export const deviceSizeStore = (state: RootState) => state.botData.currrentDeviceSize;;

